import { Column, Entity, ManyToOne, PrimaryGeneratedColumn } from "typeorm"
import { KamiTarget } from "./KamiTarget"

@Entity()
export class KamiPortRange {
  @PrimaryGeneratedColumn({ name:"id" })
  id?: number

  @ManyToOne(() => KamiTarget, (target) => target.portRanges, { onDelete:'CASCADE' })
  owner?: KamiTarget

  @Column()
  start?: number

  @Column()
  end?: number
}